"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _constant = require("../constant");

var _Full = _interopRequireDefault(require("./Full"));

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MobileMenu = function MobileMenu(_ref) {
  var _EXPAND_TYPE$FULL$EXP;

  var open = _ref.open,
      expandType = _ref.expandType,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["open", "expandType"]);
  (0, _react.useEffect)(function () {
    var overflow = document.body.style.overflow;

    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = overflow;
    }

    return function () {
      document.body.style.overflow = overflow;
    };
  }, [open]);
  return (_EXPAND_TYPE$FULL$EXP = {}, (0, _defineProperty2["default"])(_EXPAND_TYPE$FULL$EXP, _constant.EXPAND_TYPE.FULL, /*#__PURE__*/_react["default"].createElement(_Full["default"], (0, _extends2["default"])({
    open: open
  }, props))), (0, _defineProperty2["default"])(_EXPAND_TYPE$FULL$EXP, _constant.EXPAND_TYPE.SIDEBAR, /*#__PURE__*/_react["default"].createElement(_Sidebar["default"], (0, _extends2["default"])({
    open: open
  }, props))), (0, _defineProperty2["default"])(_EXPAND_TYPE$FULL$EXP, _constant.EXPAND_TYPE.DRAWER, /*#__PURE__*/_react["default"].createElement(_Drawer["default"], (0, _extends2["default"])({
    open: open
  }, props))), _EXPAND_TYPE$FULL$EXP)[expandType];
};

var _default = MobileMenu;
exports["default"] = _default;